import type { ScheduledContentResponse } from "@/types/contentCalendar";
import type { ITaskBase, ScheduledTaskResponse } from "@/types/task";
import { get } from "lodash-es";

export function useSingleTask(
  id: globalThis.ComputedRef<string> | globalThis.Ref<string>
): globalThis.UseQueryReturnType<ITaskBase | null, Error> {
  const enabled = computed(
    () => !!toValue(id) && !!currentSessionInformation.appAuthToken
  );
  const query = useQuery({
    queryKey: ["task", { id }],
    queryFn: async () => {
      const response = await useGetRequest<ITaskBase>("/tasks", {
        params: { taskId: id.value },
      });
      return get(response, "data", null);
    },
    enabled,
  });
  return query;
}

export function useSingleScheduledTask<
  T extends ScheduledContentResponse | ScheduledTaskResponse = ScheduledTaskResponse,
>(id: globalThis.ComputedRef<string> | globalThis.Ref<string>) {
  const enabled = computed(
    () => !!toValue(id) && !!currentSessionInformation.appAuthToken
  );
  const query = useQuery({
    queryKey: ["scheduled-tasks", { id }],
    queryFn: async () => {
      const response = await useGetRequest<T>("/scheduled-tasks", {
        params: { scheduledTaskId: id.value },
      });
      return get(response, "data", null);
    },
    enabled,
  });
  return query;
}
